import type { FunctionComponent } from 'react';

import { useParams } from '@tanstack/react-router';

import type { SpeakerWordIds } from '@iconik-io/shared-lib/src/react/components/panels/transcriptions_panel/types';

import { updateTranscriptionWordsSpeaker } from '../../../ducks/asset_transcriptions/thunks';
import { selectTranscriptionPartsAndSpeakerLabels } from '../../../panels/asset_transcriptions/selectors';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../store/react_redux_typed';
import ControlsModal from '../../../ui/controls_modal/controls_modal';
import Label from '../../../ui/label/label';
import withContextItems from '../context_items_hoc';
import type {
  ContextItemsHocProps,
  ModalComponentProps,
} from '../modals_manager/types';

type Props = ModalComponentProps & ContextItemsHocProps<SpeakerWordIds>;

const TranscriptionsConfirmChangeWordsSpeaker: FunctionComponent<Props> = (
  props,
) => {
  const dispatch = useAppDispatch();
  const { id: assetId } = useParams({ strict: false });
  const item = props.item;

  const { speakerLabels } = useAppSelector((state) =>
    selectTranscriptionPartsAndSpeakerLabels(state, assetId),
  );
  const speakerName = speakerLabels[item.id];

  return (
    <ControlsModal
      headerText={
        <>
          Change speaker to <strong>{speakerName}</strong>
        </>
      }
      confirmButtonText="Confirm"
      variant="warning"
      isOpen={props.isOpen}
      onCancel={props.onCancel}
      onConfirm={() => {
        const { onConfirm } = props;
        const speakerId = parseInt(item.id, 10);
        return dispatch(
          updateTranscriptionWordsSpeaker(item.wordIds, speakerId),
        ).then(onConfirm);
      }}
    >
      Do you want to change the speaker of this part to:{' '}
      <Label variant="gray">{speakerName}</Label>
    </ControlsModal>
  );
};

export default withContextItems(TranscriptionsConfirmChangeWordsSpeaker);
